import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _excluded = ["children", "l", "m", "s", "xl", "xs"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { BREAKPOINTS } from "./../../core";
import { jsx as _jsx } from "react/jsx-runtime";

var widthInPercentile = function widthInPercentile(noOfColumns) {
  return parseFloat((noOfColumns / 12 * 100).toFixed(4));
};

var xSmallStyles = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  flex-basis: ", "%;\n  flex-grow: 0;\n  max-width: ", "%;\n"])), function (_ref) {
  var xs = _ref.xs;
  return widthInPercentile(xs);
}, function (_ref2) {
  var xs = _ref2.xs;
  return widthInPercentile(xs);
});
var smallStyles = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  @media ", " {\n    flex-basis: ", "%;\n    flex-grow: 0;\n    max-width: ", "%;\n  }\n"])), BREAKPOINTS.S, function (_ref3) {
  var s = _ref3.s;
  return widthInPercentile(s);
}, function (_ref4) {
  var s = _ref4.s;
  return widthInPercentile(s);
});
var mediumStyles = css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  @media ", " {\n    flex-basis: ", "%;\n    flex-grow: 0;\n    max-width: ", "%;\n  }\n"])), BREAKPOINTS.M, function (_ref5) {
  var m = _ref5.m;
  return widthInPercentile(m);
}, function (_ref6) {
  var m = _ref6.m;
  return widthInPercentile(m);
});
var largeStyles = css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  @media ", " {\n    flex-basis: ", "%;\n    flex-grow: 0;\n    max-width: ", "%;\n  }\n"])), BREAKPOINTS.L, function (_ref7) {
  var l = _ref7.l;
  return widthInPercentile(l);
}, function (_ref8) {
  var l = _ref8.l;
  return widthInPercentile(l);
});
var xLargeStyles = css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  @media ", " {\n    flex-basis: ", "%;\n    flex-grow: 0;\n    max-width: ", "%;\n  }\n"])), BREAKPOINTS.XL, function (_ref9) {
  var xl = _ref9.xl;
  return widthInPercentile(xl);
}, function (_ref10) {
  var xl = _ref10.xl;
  return widthInPercentile(xl);
});
var StyledColumn = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  flex-basis: 0;\n  flex-grow: 1;\n  max-width: 100%;\n  ", "\n  ", "\n    ", "\n    ", "\n    ", "\n"])), function (_ref11) {
  var xs = _ref11.xs;
  return xs && xSmallStyles;
}, function (_ref12) {
  var s = _ref12.s;
  return s && smallStyles;
}, function (_ref13) {
  var m = _ref13.m;
  return m && mediumStyles;
}, function (_ref14) {
  var l = _ref14.l;
  return l && largeStyles;
}, function (_ref15) {
  var xl = _ref15.xl;
  return xl && xLargeStyles;
});

var Column = function Column(_ref16) {
  var children = _ref16.children,
      l = _ref16.l,
      m = _ref16.m,
      s = _ref16.s,
      xl = _ref16.xl,
      xs = _ref16.xs,
      other = _objectWithoutProperties(_ref16, _excluded);

  return /*#__PURE__*/_jsx(StyledColumn, _objectSpread(_objectSpread({
    xs: xs,
    s: s,
    m: m,
    l: l,
    xl: xl
  }, other), {}, {
    children: children
  }));
};

Column.displayName = "Column";
Column.propTypes = {
  /** Displays any kind of content included between opening and closing tags */
  children: PropTypes.node,

  /* Defines the number of blocks the component is going to use.
    It's applied for the `l` breakpoint and wider screens if not overridden. */
  l: PropTypes.oneOfType([PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]), PropTypes.bool]),

  /* Defines the number of blocks the component is going to use.
    It's applied for the `m` breakpoint and wider screens if not overridden. */
  m: PropTypes.oneOfType([PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]), PropTypes.bool]),

  /* Defines the number of blocks the component is going to use.
    It's applied for the `s` breakpoint and wider screens if not overridden. */
  s: PropTypes.oneOfType([PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]), PropTypes.bool]),

  /* Defines the number of blocks the component is going to use.
    It's applied for the `xl` breakpoint and wider screens if not overridden. */
  xl: PropTypes.oneOfType([PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]), PropTypes.bool]),

  /* Defines the number of blocks the component is going to use.
    It's applied for the `xs` breakpoint and wider screens if not overridden. */
  xs: PropTypes.oneOfType([PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]), PropTypes.bool])
};
Column.defaultProps = {
  children: undefined,
  l: false,
  m: false,
  s: false,
  xl: false,
  xs: false
};
export { Column };